import React from "react";
import { motion } from "framer-motion";

const skills = [
  {
    category: "Image Generation",
    tools: ["Midjourney", "Stable Diffusion"],
    icon: "🎨"
  },
  {
    category: "Video Generation",
    tools: ["RunwayML", "KlingAI"],
    icon: "🎬"
  },
  {
    category: "Content Creation",
    tools: ["OpenAI", "Gemini"],
    icon: "🤖"
  }
];

const About = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="page-container"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto space-y-12">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-center space-y-4"
          >
            <h1 className="text-4xl font-bold text-gradient">About Me</h1>
            <p className="text-xl text-muted-foreground">
              Hi! I&apos;m Sofi, a beginner digital artist from Ukraine. My illustrations are inspired by nature, emotions, and fairy tales. In my shop, you&apos;ll find unique designs for stickers, posters, clothing, and more — little touches of wonder for your everyday life.
            </p>
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="grid grid-cols-1 md:grid-cols-2 gap-6"
          >
            {skills.map((skill, index) => (
              <motion.div
                key={skill.category}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4 + index * 0.1 }}
                className="glass-card p-6 space-y-4"
              >
                <div className="text-4xl">{skill.icon}</div>
                <h3 className="text-xl font-semibold">{skill.category}</h3>
                <div className="flex flex-wrap gap-2">
                  {skill.tools.map((tool) => (
                    <span
                      key={tool}
                      className="px-3 py-1 rounded-full bg-primary/10 text-primary text-sm"
                    >
                      {tool}
                    </span>
                  ))}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default About;
